import React,{ useState,useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Modal from 'react-modal';
import {StyledTextArea} from '../../Containers/PasserCommande/PasserCommande.styles'
import {reattributionMissionChauffeur} from '../../api/commande'
import {getValidChauffeursByTransporter } from '../../api/chauffeurs'
import { useSelector } from 'react-redux'
import  toast from 'react-hot-toast'
import { CustomInput } from '../../Containers/RegisterTransporter/style';
 import { Controller } from 'react-hook-form';
 import Select from 'react-select'
import { useTranslation } from 'react-i18next';
 
const TransfertMissionChauffeur = ({ modalIsOpenTransfret, setModalIsOpenTransfret, selectedMission,setRefresh }) => {
    const { register, handleSubmit, reset, formState: { errors },control } = useForm();
    const [updateLoading, setUpdateLoading] = useState(false);
    const [chauffeurs,setChauffeurs]=useState([])

    const user = useSelector(state => state.auth.user)
	const token = useSelector((state) => state.auth.token);
   const {t} = useTranslation()
    
    const onSubmit = async (data) => {
        setUpdateLoading(true);
        if (data.distance === '') {
            data.distance = 0;
        }
        try {
            data = {
                ...data,
                missionID:selectedMission,
                transporteurID:user._id
            };

           const res= await reattributionMissionChauffeur(data,token)	
            toast.success(res.message, {
                    style: {
                        fontFamily: 'Montserrat',
                    },
                });
            setRefresh(true)
        } catch (error) {
            if (error.response && (error.response.status === 403  || 400)) {
                toast.error(error.response?.data.error || t("transfer_request_err"), {
                    style: {
                        fontFamily: 'Montserrat',
                    },
                });
            }else{
                toast.error(t("transfer_request_err"), {
                    style: {
                        fontFamily: 'Montserrat',
                    },
                });
            }
        } finally {
            setUpdateLoading(false);
            setModalIsOpenTransfret(false);
            reset()
        }
    };
    useEffect(() => {
        async function fetchChauffeurs() {
			try {
				const res = await getValidChauffeursByTransporter(user._id, token);
				setChauffeurs(res);
			} catch (error) {
				toast.error(t("transfer_request_err"), {
					style: {
						fontFamily: 'Montserrat',
					},
				});			}
		}

		fetchChauffeurs()
	}, [])
    const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth < 1024);
    
    
        useEffect(() => {
            const checkIfMobile = () => {
                setSmallScreen(window.innerWidth < 1024);
            };
            window.addEventListener('resize', checkIfMobile);
    
            return () => window.removeEventListener('resize', checkIfMobile);
        }, []);
    return (
        <Modal
            isOpen={modalIsOpenTransfret}
            style={{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    zIndex: 1000
                },
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)',
                    borderRadius: 19,
                    background: '#fff',
                    width: isSmallScreen ? '90%' : '40%',
                },
            }}
            contentLabel='Example Modal'
        >
            <div
                style={{
                   // width: '100%',
                    fontFamily: 'Montserrat',
                    display: 'flex',
                    flexDirection: 'column',
                    fontSize: 15,
                    textAlign: 'left',
                    color: '#838EAB',
                }}
            >
                <div
						style={{
							color: '#51C7F2',
							fontSize: "1.5rem",
							marginBottom: '1rem',
                            fontWeight: 'bold',
						    fontFamily: 'Montserrat',
                            textAlign:'center'
							
						}}
					>
						  {t("transfer_mission")}
	            </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div style={{ marginLeft: isSmallScreen ? '0.5rem' :'2rem', marginRight: isSmallScreen ? '0.5rem' :'2rem'}}>
                    <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                //width: '100%',
                                marginRight: '1rem',
                            }}
                        >
                           <span
                                style={{
                                 marginBottom: '.5rem',
                                 color: '#495057',
                                 fontSize: "0.8rem",
                                 fontWeight: 'bold',
                                }}
                            >
                                {t("driver")}
                            </span>
                            
                               

<Controller
    name="chauffeurID"
    control={control}  
    rules={{ required: t("transfer_mission_err1") }}
    render={({ field }) => (
        <Select
            {...field}  
            options={chauffeurs.map((c) => ({
                value: c._id,
                label: `${c.first_name} ${c.last_name}`,
            }))}
            placeholder={t("select_driver")}
            styles={{
                option: (provided, state) => ({
                    ...provided,
                    fontFamily: 'Montserrat',
                    fontSize: "0.8rem"
                }),
                menuPortal: (base) => ({
                    ...base,
                    zIndex: 2000,
                }),
                menu: (base) => ({
                    ...base,
                    zIndex: 2000,
                }),
            }}
            menuPortalTarget={document.querySelector('body')}
            onChange={(option) => field.onChange(option?.value)}  
            value={chauffeurs.map((c) => ({
                value: c._id,
                label: `${c.first_name} ${c.last_name}`,
            })).find(c => c.value === field.value)}  
        />
    )}
/>           
                            {/* <Select
				           {...register('chauffeurID',
                            { required: 'Le chauufeur est requis.'    
                            })}
                            style={{
                                padding: '0.75rem',
                                borderRadius: '8px',
                                border: '1px solid #ddd',
                                fontSize: '14px',
                                outline: 'none',
                            }}
                            
				            >
                            <option value="" >
                            Sélectionner un chauffeur
                            </option>

                           {chauffeurs.map((c) => (
                             <option key={c._id} value={c._id}>
                               {c.first_name} {c.last_name}
                             </option>
                            ))} 
				         </Select> */}
                         
                            {errors.chauffeurID && (
                                <span style={{ color: 'red', marginTop: '0.5rem' }}>
                                    {errors.chauffeurID.message}
                                </span>
                            )}
                        </div>
                     <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                                marginRight: '1rem',
                                marginTop:'1rem'
                            }}
                        >
                            <span
                                style={{
                                    marginBottom: '.5rem',
                                    color: '#495057',
                                    fontSize: "0.8rem",
                                    fontWeight: 'bold',
                                }}
                            >
                                {t("distance_traveled")}
                            </span>
                            <CustomInput
                                type='number'
                                placeholder=''
                                min={1}
                                {...register('distance')}
                                style={{
                                    width: '100%',
                                    padding: '0.75rem',
                                    borderRadius: '8px',
                                    border: '1px solid #ddd',
                                    fontSize: "0.8rem",
                                    outline: 'none',
                                }}
                            />
                        </div> 
                   
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                                marginRight: '1rem',
                                marginTop: '1rem',
                            }}
                        >
                            <span
                                style={{
                                    marginBottom: '.5rem',
                                    color: '#495057',
                                    fontSize: "0.8rem",
                                    fontWeight: 'bold',
                                }}
                            >
                                {t("note")}
                            </span>
                            <StyledTextArea
                                type='text'
                                rows={4}
                                placeholder=''
                                {...register('remarque', { required: t("note_err")})}
                                style={{
                                    width: '100%',
                                    padding: '0.75rem',
                                    borderRadius: '8px',
                                    border: '1px solid #ddd',
                                    fontSize: "0.8rem",
                                    outline: 'none',
                                  }}
                            />
                                      {errors.remarque && <span style={{ color: 'red', marginTop: '0.5rem' }}>{errors.remarque.message}</span>}

                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '1rem',
                            marginTop: '1rem',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: isSmallScreen ? 'column' : 'row',
                                width : isSmallScreen ?'100%' : ''
                            }}
                        >
                            <button
                                type='submit'
                                disabled={updateLoading}
                                style={{
                                    width: isSmallScreen ?'100%' : '150px',
                                    height: '50px',
                                    background: '#5BBCEA',
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: 'white',
                                    borderRadius: 7,
                                    marginTop: 5,
                                    fontFamily: 'Montserrat',
                                    marginRight: 10,
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}
                            >
                                {updateLoading ? (
                                    <div className='loader'></div>
                                ) : (
                                     t("transfer")
                                )}
                            </button>
                            <button
                                type='button'
                                onClick={() => {
                                    setModalIsOpenTransfret(false);
                                    reset();
                                }}
                                style={{
                                    width:  isSmallScreen ?'100%' :'150px',
                                    height: '50px',
                                    background: 'red',
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: 'white',
                                    borderRadius: 7,
                                    marginTop: 5,
                                    fontFamily: 'Montserrat',
                                    fontWeight: 'bold',
                                  }}
                            >
                                {t("cancel")}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default TransfertMissionChauffeur;